import { ModelBase } from 'store/model-base';

export class CmsNowNumberLock extends ModelBase {
    public static storeName: string = 'cmsNowNumberLock';

    public confirmation: NowNumberLockOption;
    public result: NowNumberLockResult;
}
